// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"449ad2d1","337":"573b43e7","453":"90b1d759","455":"bed37e46"}[chunkId] + ".chunk.js";
};